export const ActionTypes = {
    setStylist: "SETSTYLIST",
    setMenue: "SETMENUE",
    reserveSchedule: "RESERVESCHEDULE",
    setUserInfo: "USERINFO",
} as const